baseApp.directive('constraint', function() {
    return {
        templateUrl: '/public/directives/constraint.html',
        scope: {
            item: "=",
            index: "=",
            config: "=",
            id: "=",
            immutable: "=",
            show: "=",
            alwaysShowCurrent: "=?",
            icon: '@',
        },
        controller: function($scope, $element, $timeout) {
            $scope.showConstraint = false;
            $scope.dayNames = {1:"Sun.",2:"Mon.",3:"Tue.",4:"Wed.",5:"Thu.",6:"Fri.",7:"Sat."};
            $scope.getTimeDisplay = function(time){
               if(!time) return "";
               return $scope.getHourDisplay(time.from) + "-" + $scope.getHourDisplay(time.to);
            };
            $scope.getHourDisplay = function(hour){
               if(hour == null) return "N/A";
               var hours = Math.floor(hour/60);
               var minutes = (hour % 60 == 0) ? "00":"30";
               var ampm = hours < 12 ? " AM":" PM";
               if(hours == 0){ //midnight
                   hours = 12;
               }
               return hours + ":" + minutes +" " + ampm;
            };
            $scope.addItem = function() {
               $scope.config.editConstraints($scope.item,"constraint_" + $scope.id + $scope.index);
            };
            $scope.getTitle = function(){
                if($scope.alwaysShowCurrent) return "";
               if(!$scope.item || !$scope.item.constraint || !$scope.item.constraint.predicates ) return "Limit To";
               var predicates = $scope.item.constraint.predicates;
               for(var key in predicates){
                  if(predicates[key].values && predicates[key].values.length > 0){
                      return "Limited to:";
                  }
               }
               return "Limited to:";
            };

            var $el = $($element[0]);

            $scope.showConstraintTooltip = function(){
                $scope.showConstraint = true;
                $timeout(function(){
                    const $tooltip = $el.children('.tooltip');
                    $tooltip.css({
                        marginTop: -($tooltip.height()) - 10,
                        marginLeft: -(($tooltip.width() / 2) - ($el.children('.icon-wrapper').width() / 2))
                    });
                }, 1, false);
            };

            $scope.hideConstraintToolip = function() {
                $scope.showConstraint = false;
            };

            $scope.hasConstraint = function(item) {
                return (item && (((item.constraint) && (!_.isEmpty(item.constraint) && !angular.equals(item.constraint, {"predicates":[],"op":"OP_EQ"}) && !angular.equals(item.constraint, {"predicates":{},"op":"OP_EQ"}))) || ((item.alertConstraint) && !_.isEmpty(item.alertConstraint))));
            };
            $scope.equalItem = function(item) {
            return !angular.equals(item.constraint, {"predicates":[],"op":"OP_EQ"})};
        }
    };
});


baseApp.directive('splitter', function() {
    return {
       link:function($scope, element, attrs){
	       
			$scope.split = function(){
		        $(element).css("height",$( window ).height() - 184).split({
				    orientation: attrs.orientation?attrs.orientation:'horizontal',
				    position: attrs.position
			    });
		    };

		    if (attrs.disable === undefined || attrs.disable === 'false'){
		        $scope.split();
			    $(window).resize(function() {
				    $scope.split();
			    });
			}

           $scope.$on('$destroy', function () {
               $(element).split().destroy();
           });
       }
    }
});



baseApp.directive('chxToggle', function() {
    return {
        template: function(){
            return ('<div class="togglebutton"><label><input id="{{id}}" type="checkbox" ng-model="chked" /></label></div>');
        },
        replace: true,
        scope: {
            chked: "=",
            id: "@"
        },
        link:function($scope, element){
           var $input = $(element).find('input');

           $input.click(function($event){
               $event.stopPropagation();
               $scope.$parent.$emit("$toggleClicked",$input.attr("id"),!$input.is(":checked"), $scope.chked);
           });

            $scope.$on('$destroy', function () {
                $input.off();
            });
        }
    }
});

baseApp.directive('tooltip', function() {
    return {
       scope: {
            tooltipvalue: "="
       },
       link:function($scope, element){
           element[0].setAttribute("data-toggle", "tooltip");
           element[0].setAttribute("title", $scope.tooltipvalue);
       }
    }
});


baseApp.directive('timeSettings', function() {
    return {
        templateUrl: '/public/directives/timesettings.html',
        scope: {
            timeDef: "=",
            chooseMode: "@"
        },
        controller: ['$scope', 'GeneralUtilsService', function($scope, GeneralUtilsService) {
            var hours = [];
            var minutesInDay = 48;
            for(var i = 0 ; i < minutesInDay ; i++){
                var hour = Math.floor(i / 2);
                if(hour >= 12){
                   hour -= 12;
                }
                var hourDisplay =  hour + ":";
                if(hourDisplay == "0:"){
                   hourDisplay = "12:";
                }
                if(i % 2 == 0){
                    hourDisplay += "00";
                }
                else {
                    hourDisplay += "30";
                }
                if( i < 24 ) {
                    hourDisplay += " AM";
                }
                else {
                    hourDisplay += " PM";
                }
                
                hours.push({"value":i * 30,"display":hourDisplay});
            }
            $scope.hours = hours;
            
            $scope.toggleSelection = function(item,arr) {
                GeneralUtilsService.toggleSelection(arr,item);
		    }
        }]
    };
});

